import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
	appBar: {
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),
		backgroundColor: theme.palette.primary.main,
		boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.135216)"
	},
	drawer: {
		width: 300,
		"& .MuiDrawer-paper": {
			height: "calc(100% - 64px)",
			marginTop: 64
		}
	},
	drawerOpen: {
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		})
	},
	drawerClose: {
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		})
	},
	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: "0 8px",
		...theme.mixins.toolbar
	},
	siteName: {
		fontStyle: "normal",
		fontWeight: 900,
		fontSize: "22px",
		letterSpacing: "1px",
		backgroundColor: "#798739",
		color: "white",
		fontFamily: "Roboto",
		textTransform: "capitalize",
		textAlign: "center",
		lineHeight: "64px"
	}
}));
